// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TheLanguageSwitcher_wrapper_rZn5f","currentLanguage":"TheLanguageSwitcher_currentLanguage_3kvzN","languageSwitcher":"TheLanguageSwitcher_languageSwitcher_3MjUa"};